const locale = {
	DASHBOARDS: 'Dashboard',
	MANAGETASTE: 'Tastes',
	MANAGECATEGORIES: 'Categories',
	STORES: 'Stores',
	STOREREPORT: 'Store Report',
	UPLOADINVOICE: 'Upload FIle of Invoices',
	MANAGEPLACES:'All Places',
	PLACE:'Places',
	MANAGECUSTOMERSPLACES:'Added by Customers',
	CLAIMREQUESTS:'Claimed by Owners',
	MANAGECUSTOMERS:'Customers',
	MANAGEOWNERS:'Owners',
	MANAGEFEATURES:'Features',
	MANAGEEVENTS:'Events',
	MANAGEORDERS:'Food Orders',
	MANAGELANGUAGE:'Language',
	MANAGENEWSLATTER:'Newsletter',
	MANAGESTATICPAGE:'Content Pages',
	MANAGEFAQPAGE:'Faq',
	SUGGETIONEDIT:'Suggested Edits by Customers',
	MANAGETERMS:'Terms',
	CLAIMREQUESTSCUSTOMER:'Claimed by Customers',
	REPORTED:'Reported by Customers'
};

export default locale;
